module.exports = __webpack_public_path__ + "static/media/55.c60cbfcb.png";